namespace Nobox {

    @Serenity.Decorators.registerFormatter()
    export class TglFormatter implements Slick.Formatter {
        @Serenity.Decorators.option()
        public withTime?: boolean;
        @Serenity.Decorators.option()
        public noTz?: boolean;
        getCookie(name) {
            const value = `; ${document.cookie}`;
            const parts = value.split(`; ${name}=`);
            if (parts[1] == undefined) {
                if (name == "formatdate") {
                    return "DD-MM-YYYY";
                } else if (name == "formattime") {
                    return "HH:mm";
                } else if (name == "timezone") {
                    return "Asia/Jakarta";
                }
            } else {
                return parts[1].split(';').shift();
            }
        }
        regexDateTime(format) {
            return format.replace(new RegExp("%2C", 'g'), ",").replace(new RegExp("%2F", 'g'), "/").replace(new RegExp("%20", 'g'), " ").replace(new RegExp("%3A", 'g'), ":");
        }
        format(ctx: Slick.FormatterContext) {
            function getCookie(name) {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; ${name}=`);
                if (parts[1] == undefined) {
                    return null;
                } else {
                    return parts[1].split(';').shift();
                }
            }

            var timezone = "";
            if (ctx.value == "" || ctx.value == null) {
                return "";
            } else {
                if (this.noTz == true) {
                    var finalV = moment(ctx.value).format(this.regexDateTime(this.getCookie("formatdate")));
                    return `<span title="${finalV}">${finalV}</span>`;
                } else {
                    if (getCookie("timezone") == undefined || getCookie("timezone") == "" || getCookie("timezone") == null) {
                        timezone = "Asia/Jakarta";
                    } else {
                        timezone = getCookie("timezone").replace(new RegExp("%2F", 'g'), "/").replace(new RegExp("%2C", 'g'), ",");
                    }
                    if (this.withTime == true) {
                        var finalV = moment(ctx.value).tz(timezone).format(this.regexDateTime(this.getCookie("formatdate")) + " " + this.regexDateTime(this.getCookie("formattime")));
                        return `<span title="${finalV}">${finalV}</span>`;
                    } else {
                        var finalV = moment.utc(ctx.value).tz(timezone).format(this.regexDateTime(this.getCookie("formatdate")));
                        return `<span title="${finalV}">${finalV}</span>`;
                    }
                }
            }
        }
    }
}